import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs'; 

@Injectable({
  providedIn: 'root' 
})
export class StepperService {
  
  private totalSteps = 0;

  private currentIndex = new BehaviorSubject<number>(0);
  
  public currentStep$ = this.currentIndex.asObservable();

  public setSteps(total: number, resetIndex: boolean = true): void {
    this.totalSteps = total;
    
    if (resetIndex) {
      this.currentIndex.next(0);
    } else {
      const currentIdx = this.currentIndex.value;
      if (currentIdx >= total) {
        this.currentIndex.next(total - 1);
      }
    }
  }

  public next(): void {
    const nextStep = this.currentIndex.value + 1;
    if (nextStep < this.totalSteps) {
      this.currentIndex.next(nextStep);
    }
  }

  public previous(): void {
    const prevStep = this.currentIndex.value - 1;
    if (prevStep >= 0) {
      this.currentIndex.next(prevStep);
    }
  }

  public goToStep(index: number): void {
    if (index >= 0 && index < this.totalSteps) {
      this.currentIndex.next(index);
    }
  }

  public getCurrentIndex(): number {
    return this.currentIndex.value;
  }
}